import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { SherpaCustomersControllerModule } from './controllers/SherpaCustomersController';
import { SherpaCustomersOrdersDetailView } from './orders/detail/detail';
import { SherpaCustomersOrdersView } from './orders/orders';

export const SherpaCustomersView = angular
  .module('acme.view.application.sherpa.customers', [
    uiRouter,
    'ui.bootstrap',
    SherpaCustomersControllerModule,
    SherpaCustomersOrdersView,
    SherpaCustomersOrdersDetailView,
    'acme.view.application.sherpa.activities.tenant',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.sherpa.customers',
      url: '/customers?list',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'SherpaCustomersController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/sherpa/customers/customers.tpl.html',
        },
      },
      data: {
        pageTitle: 'CSR Customers',
        permissions: ['CSR'],
      },
    });

    $stateProvider.state({
      name: 'application.sherpa.customers.list',
      url: '',
      views: {
        'subview-main': {
          templateUrl: 'views/application/views/sherpa/customers/customersList.tpl.html',
        },
      },
      data: {
        pageTitle: 'CSR Customers',
      },
    });
  }).name;
